import { useContext, useMemo, useRef } from 'react';
import { UseRouterDefaultsContext } from '../routerContext';
import { createRequestService } from '../requestService';
import { createRouter } from '../routerService';
import { useRouterService } from './useRouterService';
export function useRouter(routerFunction, options) {
    if (options === void 0) { options = {}; }
    var defaults = useContext(UseRouterDefaultsContext);
    var _a = options.requestService, requestServiceProp = _a === void 0 ? defaults.requestService : _a, _b = options.initialSnapshot, initialSnapshot = _b === void 0 ? defaults.initialSnapshot : _b, onResponseComplete = options.onResponseComplete, _c = options.transitionTimeoutMs, transitionTimeoutMs = _c === void 0 ? defaults.transitionTimeoutMs : _c, unstable_isConcurrent = options.unstable_isConcurrent;
    var requestServiceRef = useRef(requestServiceProp);
    if (requestServiceProp) {
        requestServiceRef.current = requestServiceProp;
    }
    if (!requestServiceRef.current && typeof window !== 'undefined') {
        requestServiceRef.current = createRequestService();
    }
    if (!requestServiceRef.current) {
        throw new Error("On the server, you must provide a history object to useRouter.");
    }
    var requestService = requestServiceRef.current;
    var routerService = useMemo(function () { return createRouter(routerFunction, requestService, { initialSnapshot: initialSnapshot }); }, [requestService, routerFunction, initialSnapshot]);
    return useRouterService(routerService, {
        onResponseComplete: onResponseComplete,
        transitionTimeoutMs: transitionTimeoutMs,
        unstable_isConcurrent: unstable_isConcurrent,
    });
}
